import { Controller } from '@hotwired/stimulus';
import Hls from 'hls.js';

export class VideoController extends Controller {
  static targets = [
    'button',
    'video',
    'playTemplate',
    'pauseTemplate',
  ];
  static values = {
    autoplay: Boolean,
  };

  disconnect() {
    if (this.hls) this.hls.destroy();
  }

  connect() {
    if (this.autoplayValue) this.play();
  }

  async pause() {
    await this.videoTarget.pause();

    if (
      this.hasButtonTarget
      && this.hasPlayTemplateTarget
    ) this.buttonTarget.innerHTML = this.playTemplateTarget.innerHTML;
  }

  async play() {
    await this.ensureHlsLoaded();
    await this.videoTarget.play();

    if (
      this.hasButtonTarget
      && this.hasPauseTemplateTarget
    ) this.buttonTarget.innerHTML = this.pauseTemplateTarget.innerHTML;
  }

  async toggle() {
    if (!this.hasVideoTarget) return;
    if (this.videoTarget.paused) return await this.play();

    await this.pause();
  }

  async ensureHlsLoaded() {
    const src = this.videoTarget.getAttribute('src');

    if (!src || this.hls) {
      return;
    }

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(src);
      this.hls.attachMedia(this.videoTarget);

      await new Promise((resolve, reject) => {
        const onParsed = () => {
          this.hls.off(Hls.Events.MANIFEST_PARSED, onParsed);
          resolve();
        };

        this.hls.on(Hls.Events.MANIFEST_PARSED, onParsed);
        this.hls.on(Hls.Events.ERROR, () => reject());
      });
    }
  }
}
